import { useTenant } from '@providers/Tenant';
import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { instructionQueryKeys } from '../../shared/api/queryKeys';
import { AnimationsService } from '../api/animationsService';
import { Animation } from '../model/animation';

export function useSaveAnimation() {
  const queryClient = useQueryClient();
  const { accountId } = useTenant();
  const service = useMemo(() => new AnimationsService(), []);

  return useMutation<unknown, unknown, { stepId: string; animation: Animation }>({
    mutationFn: ({ stepId, animation }) => service.save(accountId, stepId, animation),
    onSuccess: (data, { stepId, animation }) => {
      addAnimationToCache(queryClient, animation, stepId);
    },
  });
}

function addAnimationToCache(queryClient: QueryClient, animation: Animation, stepId: string) {
  queryClient.setQueryData<Animation>([instructionQueryKeys.getAnimation, stepId], () => animation);
}
